import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  withXSRFToken: true,
});

export const useHttp = () => client;

/**
 * Headers that let the server answer a retried write with its first response,
 * so a request whose response was lost can be repeated without doing it twice.
 */
export const idempotencyHeaders = (key?: string): Record<string, string> =>
  key ? { 'Idempotency-Key': key } : {};
